import { Dictionary } from '@feedyou-ai/feedbot-schema'

export type IdsByIdMap<
  Key extends string = string, // I <3 PRETTIER
  Value extends string = string
> = Dictionary<Key, Value[]>

// { x: ['a', 'b'], y: ['a'] }
// ->
// { a: ['x', 'y'], b: ['x'] }
export const invertIdsByIdMap = <
  Key extends string = string, // I <3 PRETTIER
  Value extends string = string
>(
  list: IdsByIdMap<Key, Value>
): IdsByIdMap<Value, Key> => {
  return Object.entries(list).reduce((out, entry) => {
    const [id, subIdsList] = entry as [Key, Value[]]

    subIdsList?.forEach(subId => {
      if (!out[subId]) {
        out[subId] = []
      }

      out[subId].push(id)
    })

    return out
  }, {} as IdsByIdMap<Value, Key>)
}
